
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-download",
  "use": "icon-material-download-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-download\"><path d=\"M480-315.15 278.39-516.76l48.98-48.5L445.93-446.7v-359.52h68.14v359.52l118.56-118.56 48.98 48.5zM222.15-154.02q-27.6 0-47.86-20.27-20.27-20.26-20.27-47.86v-143h68.13v143h515.7v-143h68.37v143q0 27.58-20.34 47.86-20.33 20.27-48.03 20.27z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-download"/>
                </svg>
            );
        };

        Icon.id = "icon-material-download";

        export default Icon;
    